import { useEffect, useState } from "react";
import { incrementVisit, getVisitStats, getDailyVisits } from "../visitCounter";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function Estadisticas() {
  const [stats, setStats] = useState({ total: 0, hoy: 0, semana: 0 });
  const [grafica, setGrafica] = useState([]);

  useEffect(() => {
    incrementVisit();
    getVisitStats().then(setStats);
    getDailyVisits().then(setGrafica);
  }, []);

  return (
    <div style={{ padding: "2rem" }}>
      <h1>📊 Estadísticas de Hi Blinds</h1>
      <p>👀 Visitas hoy: <strong>{stats.hoy}</strong></p>
      <p>📅 Visitas esta semana: <strong>{stats.semana}</strong></p>
      <p>📈 Visitas totales: <strong>{stats.total}</strong></p>

      <h2 style={{ marginTop: "2rem" }}>Gráfica de visitas por día</h2>
      <div style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer>
          <LineChart data={grafica}>
            <CartesianGrid stroke="#ccc" />
            <XAxis dataKey="fecha" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="visitas" stroke="#8884d8" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}